import { tracking } from '@iwoca/frontend-tracking-library';
import { driver } from 'driver.js';
import { getAmplitudeDefaultEventProperties } from 'utils/amplitudeEvents';

const trackClick = (tourName: string, buttonText: string) => {
  tracking.ampli.ctaClick({
    ...getAmplitudeDefaultEventProperties(),
    'CTA text': buttonText,
    category: tourName,
  });
};

const navigationTour = driver({
  showProgress: true,
  showButtons: ['next', 'close'],
  popoverClass: 'driver-popover-custom',
  steps: [
    {
      element: '#nav-ctas-left',
      popover: {
        title: '🚀 Welcome to the Portal',
        description: `<p>You can always access the <strong>Dashboard</strong> to manage applications, explore <strong>Products</strong> we offer, and use the <strong>Calculator</strong> for quick estimates.</p><p>Click <strong>“Create a new app”</strong> anytime to start a new application.</p>`,
        side: 'bottom',
        align: 'center',
        nextBtnText: 'Next',
        onNextClick: () => {
          navigationTour.moveNext();
          trackClick('Navigation', 'Next');
        },
      },
      disableActiveInteraction: true,
    },
    {
      element: '#nav-ctas-right',
      popover: {
        title: '💡 Helpful tools and support',
        description: `<p>Stay up to date with <strong>What's New</strong>, find quick answers in <strong>FAQs</strong>, or click your profile icon to invite colleagues and relaunch tours.</p><p>These tools are here to support you as you create applications.</p>`,
        nextBtnText: 'Got it',
        side: 'bottom',
        align: 'center',
        onNextClick: () => {
          navigationTour.destroy();
          trackClick('Navigation', 'Got it');
        },
      },
      disableActiveInteraction: true,
    },
  ],
});

export const useTutorials = () => {
  const triggerNavigationTour = () => {
    navigationTour.drive();
  };
  return {
    triggerNavigationTour,
  };
};
